(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/start-bingo-game/assets/javascripts/start-bingo-game.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/start-bingo-game/assets/javascripts/start-bingo-game.js');
"use strict";


const aliasDialog = svs.bingo_react.components.common.dialog.aliasDialog;
const fetchAlias = svs.bingo_react.components.api.fetchAlias;
const canPlayOnVertical = svs.accountservices.player_exclusions.canPlayOnVertical;
const cmsGames = svs.bingo_react.data.cmsGames;
const bingoBaseUrl = svs.core.urlMapping.get('bingoHome');
const buildGameUrl = gameId => {
  var _cmsGames$find;
  const gameName = (_cmsGames$find = cmsGames.find(cmsGame => cmsGame.id === gameId)) === null || _cmsGames$find === void 0 ? void 0 : _cmsGames$find.title;
  let qs = '';
  if (gameName) {
    const params = new URLSearchParams();
    params.set('gameName', gameName);
    qs = "?".concat(params);
  }
  return "".concat(bingoBaseUrl, "/spela/").concat(gameId).concat(qs);
};
const trackClick = promoPosition => {
  if (!promoPosition) {
    return;
  }
  const evt = {
    id: bingoBaseUrl,
    name: "bingo-card-".concat(promoPosition),
    position: promoPosition
  };
  svs.components.analytics.trackPromoClick(evt);
};
const startBingoGame = async (gameId, promoPosition) => {
  trackClick(promoPosition);
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const gameUrl = buildGameUrl(gameId);
  if (!isLoggedIn) {
    svs.components.customer_login.login({
      cancelUrl: bingoBaseUrl,
      returnUrl: gameUrl
    });
  } else {
    const canPlay = await canPlayOnVertical('bingo');
    if (canPlay) {
      const alias = await fetchAlias();
      if (!alias) {
        aliasDialog.open();
      } else {
        svs.utils.url.navigate(gameUrl);
      }
    }
  }
};
setGlobal('svs.bingo_react.components.startBingoGame', startBingoGame);

 })(window);